export default function Dined() {
    return (
        <div className="alert alert-danger dined" role="alert">
            У вас нет прав для просмотра этой страницы. Обратитесь к администратору.
        </div>
    )
}